import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { InputComponentWrapper, ValidationErrorWrapper } from '../../constants';
import { ValidationService } from '../validation.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'conn-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputComponent implements OnInit, OnChanges {
  private readonly validationService = inject(ValidationService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() placeholder: string;
  @Input() submitted: boolean; // used to toggle validation and notify component when parents have attempted to submit
  @Input() inputModel = ''; // IF THIS IS USED YOU NEED TO add the ngDefaultControl directive:
  // https://stackoverflow.com/questions/46465891/what-is-ngdefaultcontrol-in-angular
  @Input() required: boolean; // tied into navigation if this component is required
  @Input() labelName: string; // optional label name used for component
  @Input() validationCallback: (s: string) => ValidationErrorWrapper;
  @Input() errorMessage: string;
  @Input() isReadOnly = false;
  @Output() modelChanged: EventEmitter<InputComponentWrapper>;
  @Output() customBlur: EventEmitter<Event>;
  environment = environment;
  isValid: boolean;

  constructor() {
    this.modelChanged = new EventEmitter<InputComponentWrapper>();
    this.customBlur = new EventEmitter<Event>();
  }

  ngOnInit() {
    this.isValid = this.isModelValue();
  }

  changeModel(changedData: string) {
    if (changedData !== undefined && changedData !== this.inputModel) {
      this.inputModel = changedData;
      this.isValid = this.isModelValue();
      this.submitted = false;
      this.modelChanged.emit({
        inputText: changedData,
        isValid: this.isValid,
      } as InputComponentWrapper);
    }
  }

  emitBlur() {
    this.submitted = true;
    this.customBlur.emit(new Event('blur'));
  }

  /**
   * This will check to see if a validationCallback function has been provided.  If so it'll use that to
   * determine it's validation state.  Otherwise this will simply check and make sure the input is required and not
   * empty.
   */
  isModelValue(): boolean {
    if (!!this.validationCallback) {
      const wrapper: ValidationErrorWrapper = this.validationCallback(
        this.inputModel,
      );
      this.errorMessage = wrapper.errorMessage;
      return wrapper.isValid;
    } else {
      return this.validationService.isBasicInputValid(
        this.inputModel,
        this.required,
      );
    }
  }

  // Allows parent of component to trigger validation
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['validationCallback'] &&
      !changes['validationCallback'].firstChange
    ) {
      this.isValid = this.isModelValue();
      this.cdr.markForCheck();
    }
  }
}
